import { Component, OnInit, VERSION } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PasswordService } from '../services/login/password.service';

@Component({
  selector: 'app-login',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  registerForm: FormGroup;
  contentCmsIntro: any;
  contentCmsTips: any;
  logo: string;

  public version = VERSION.full;
  public reactiveForm: FormGroup = new FormGroup({
    recaptchaReactive: new FormControl(null, Validators.required)
  });

  constructor(private router: Router, private formBuilder: FormBuilder, private toastr: ToastrService,
    private passwordService: PasswordService) { }


  ngOnInit() {
    this.getCmsIntro();
    this.getCmsTips();
    this.logo = localStorage.getItem('logo');
  }

  recoveryPassword(form: NgForm) {
    let userEmail = form.value.inputEmail;
    let capcha = form.value.capcha;

    this.registerForm = this.formBuilder.group({
      email: [userEmail, [Validators.required, Validators.email]],
      capcha: [capcha, [Validators.required]]
    });

    if (this.registerForm.invalid) {
      if (this.registerForm.controls.email.errors) {
        if (this.registerForm.controls.email.errors.email) {
          this.showError('Lo sentimos! El correo tiene un formato incorrecto');
          return;
        }
        if (this.registerForm.controls.email.errors.required) {
          this.showError('Lo sentimos! Debe ingresar un correo válido');
          return;
        }
      }
      if (this.registerForm.controls.capcha.errors) {
        if (this.registerForm.controls.capcha.errors.required) {
          this.showError('Debe seleccionar el captcha para restablecer la contraseña');
          return;
        }
      }
    }

    this.passwordService.recoveryPassword(userEmail)
      .subscribe((passResponse: any) => {
        if (passResponse.error) {
          this.showError(passResponse.message);
        }
        if (!passResponse.error) {
          this.router.navigate(['/login']);
          this.showSucces('Se ha enviado una nueva clave de acceso a su correo');
        }
      });
  }


  showError(message: string) {
    this.toastr.error(message);
  }

  showSucces(message: string) {
    this.toastr.success(message);
  }

  getCmsIntro() {
    const ubication = 'RESTABLECER_PASSWORD_INTRO_AGR';
    this.passwordService.contentIntro(ubication)
      .subscribe((cmsResponseIntro: any) => {
        return this.contentCmsIntro = cmsResponseIntro;
      });
  }

  getCmsTips() {
    const ubication = 'RESTABLECER_PASSWORD_TIP_AGR';
    this.passwordService.contentTips(ubication)
      .subscribe((cmsResponseTips: any) => {
        return this.contentCmsTips = cmsResponseTips;
      });
  }
}
